import { render, staticRenderFns } from "./RentedProductForm.vue?vue&type=template&id=6d72cd0f"
import script from "./RentedProductForm.vue?vue&type=script&lang=js"
export * from "./RentedProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports